<div class="balloon-container w-100" *ngIf="showBalloons && randomBalloons.length == 100" [ngStyle]="{'height': customHeight ? customHeight : '100%'}">
  <div class="pyro">
    <div class="before"></div>
    <div class="after"></div>
  </div>
  <div class="balloon" *ngFor="let item of randomBalloons" [style]="item | keepStyle" >

  </div>
</div> 